import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

const baseURI = 'catalogos/funcion-presupuestal/';

/**
 * GET Funciones Presupuestales
 * @returns {Promise<Array<Object>>}
 */
export const getFuncionesPresupuestales = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Funciones Presupuestales
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postFuncionesPresupuestales = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * PATCH Funciones Presupuestales
 * @param {number} id
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const patchFuncionesPresupuestales = async (id, values) => {
  try {
    const response = await API.patch(`${baseURI}${id}`, values);
    onSuccess(response, 'Editado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Funciones Presupuestales
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteFuncionesPresupuestales = async (id) => {
  try {
    const response = await API.delete(`${baseURI}${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
